import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@components/atoms/typography';
import { Box, Stack } from '@mui/material';
import { useAppTheme } from '@theme';

import { getStartCustomPartnerSx } from '../styles';

const HOW_DOES_IT_WORK_STEPS = ['step1', 'step2', 'step3', 'step4'] as const;

type FaqAnswerProps = {
    faqKey: 'whatIsDataSpike' | 'howDoesItWork' | 'dataProtection' | 'howLongDoesItTake';
};

export const FaqAnswer: React.FC<FaqAnswerProps> = ({ faqKey }) => {
    const { t } = useTranslation();
    const theme = useAppTheme();
    const sx = useMemo(() => getStartCustomPartnerSx(theme), [theme]);
    const translationKey = `docVerificationWidget.startCustomPartner.faq.${faqKey}`;

    if (faqKey === 'howDoesItWork') {
        return (
            <Stack
                sx={{
                    gap: 1,
                }}
            >
                <Box
                    component='ul'
                    sx={{
                        m: 0,
                        pl: 2.5,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 0.5,
                    }}
                >
                    {HOW_DOES_IT_WORK_STEPS.map((step) => (
                        <Typography key={step} tag='li' variant='text' color='text-main'>
                            {t(`${translationKey}.${step}`)}
                        </Typography>
                    ))}
                </Box>
            </Stack>
        );
    }

    if (faqKey === 'howLongDoesItTake') {
        return (
            <Stack
                sx={{
                    gap: 1,
                }}
            >
                <Typography tag='p' variant='text' color='text-main'>
                    {t(`${translationKey}.answer`)}
                </Typography>
                <Stack sx={sx.noticeBox}>
                    <Typography tag='p' variant='big-text-bold' color='text-main'>
                        {t(`docVerificationWidget.startCustomPartner.notice.title`)}
                    </Typography>
                    <Typography tag='p' variant='text' color='text-main'>
                        {t(`${translationKey}.noticeText`)}
                    </Typography>
                </Stack>
            </Stack>
        );
    }

    return (
        <Typography tag='p' variant='text' color='text-main'>
            {t(`${translationKey}.answer`)}
        </Typography>
    );
};
